import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-gradient-to-br from-background via-card to-muted overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-10 left-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 bg-primary rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 md:w-56 md:h-56 lg:w-72 lg:h-72 bg-accent rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center space-y-6 md:space-y-8 lg:space-y-10">
          {/* Main headline */}
          <div className="space-y-3 md:space-y-4">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
              <Icon name="Heart" size={20} color="var(--color-primary)" strokeWidth={2} />
              <span className="caption text-primary font-medium">Safe Space for Emotional Expression</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground leading-tight">
              Your Emotional Cuts,
              <br />
              <span className="text-primary">Shared Anonymously</span>
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              A safe, judgment-free space where you can share your emotional struggles anonymously. Please write anonymously and avoid identifying details.
            </p>
          </div>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button
              variant="default"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/main-feed')}
              className="w-full sm:w-auto"
            >
              Enter Safe Space
            </Button>
            
            <Button
              variant="outline"
              size="lg"
              iconName="Info"
              iconPosition="left"
              onClick={() => {
                document.getElementById('how-it-works')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="w-full sm:w-auto"
            >
              How It Works
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 pt-8 md:pt-12">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Shield" size={18} color="var(--color-success)" strokeWidth={2} />
              <span>100% Anonymous</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Lock" size={18} color="var(--color-success)" strokeWidth={2} />
              <span>Privacy Protected</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="Users" size={18} color="var(--color-success)" strokeWidth={2} />
              <span>Supportive Community</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;